var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyElementBase, SurveyQuestionElementBase, } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionRanking = /** @class */ (function (_super) {
    __extends(SurveyQuestionRanking, _super);
    function SurveyQuestionRanking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionRanking.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionRanking.prototype.renderElement = function () {
        var _this = this;
        if (!this.question.selectToRankEnabled) {
            return (React.createElement("div", { className: this.question.rootClass, ref: function (root) { return (_this.setControl(root)); } }, this.getItems()));
        }
        else {
            var unrankedItem = true;
            return (React.createElement("div", { className: this.question.rootClass, ref: function (root) { return (_this.setControl(root)); } },
                React.createElement("div", { className: this.question.getContainerClasses("from"), "data-ranking": "from-container" },
                    this.getItems(this.question.renderedUnRankingChoices, unrankedItem),
                    this.question.renderedUnRankingChoices.length === 0 ? React.createElement("div", { className: this.question.cssClasses.containerPlaceholder },
                        " ",
                        this.renderLocString(this.question.locSelectToRankEmptyRankedAreaText),
                        " ") : null),
                React.createElement("div", { className: this.question.cssClasses.containersDivider }),
                React.createElement("div", { className: this.question.getContainerClasses("to"), "data-ranking": "to-container" },
                    this.getItems(),
                    this.question.renderedRankingChoices.length === 0 ? React.createElement("div", { className: this.question.cssClasses.containerPlaceholder },
                        " ",
                        this.renderLocString(this.question.locSelectToRankEmptyUnrankedAreaText),
                        " ") : null)));
        }
    };
    SurveyQuestionRanking.prototype.getItems = function (choices, unrankedItem) {
        var _this = this;
        if (choices === void 0) { choices = this.question.renderedRankingChoices; }
        var items = [];
        var _loop_1 = function (i) {
            var item = choices[i];
            items.push(this_1.renderItem(item, i, function (event) {
                _this.question.handleKeydown.call(_this.question, event, item);
            }, function (event) {
                event.persist();
                //event.preventDefault();
                _this.question.handlePointerDown.call(_this.question, event, item, event.currentTarget);
            }, function (event) {
                event.persist();
                //event.preventDefault();
                _this.question.handlePointerUp.call(_this.question, event, item, event.currentTarget);
            }, this_1.question.cssClasses, this_1.question.getItemClass(item), this_1.question, unrankedItem));
        };
        var this_1 = this;
        for (var i = 0; i < choices.length; i++) {
            _loop_1(i);
        }
        return items;
    };
    SurveyQuestionRanking.prototype.renderItem = function (item, i, handleKeydown, handlePointerDown, handlePointerUp, cssClasses, itemClass, question, unrankedItem) {
        var key = "id-" + item.renderedId;
        var text = this.renderLocString(item.locText);
        var index = i;
        var indexText = this.question.getNumberByIndex(index);
        var tabIndex = this.question.getItemTabIndex(item);
        var renderedItem = (React.createElement(SurveyQuestionRankingItem, { key: item.uniqueId, text: text, index: index, indexText: indexText, itemTabIndex: tabIndex, handleKeydown: handleKeydown, handlePointerDown: handlePointerDown, handlePointerUp: handlePointerUp, cssClasses: cssClasses, itemClass: itemClass, question: question, unrankedItem: unrankedItem, item: item }));
        var survey = this.question.survey;
        var wrappedItem = null;
        if (!!survey) {
            wrappedItem = ReactSurveyElementsWrapper.wrapItemValue(survey, renderedItem, this.question, item);
        }
        return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
    };
    return SurveyQuestionRanking;
}(SurveyQuestionElementBase));
export { SurveyQuestionRanking };
var SurveyQuestionRankingItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionRankingItem, _super);
    function SurveyQuestionRankingItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "text", {
        get: function () {
            return this.props.text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "index", {
        get: function () {
            return this.props.index;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "indexText", {
        get: function () {
            return this.props.indexText;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "handleKeydown", {
        get: function () {
            return this.props.handleKeydown;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "handlePointerDown", {
        get: function () {
            return this.props.handlePointerDown;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "handlePointerUp", {
        get: function () {
            return this.props.handlePointerUp;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "cssClasses", {
        get: function () {
            return this.props.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "itemClass", {
        get: function () {
            return this.props.itemClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "itemTabIndex", {
        get: function () {
            return this.props.itemTabIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "unrankedItem", {
        get: function () {
            return this.props.unrankedItem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionRankingItem.prototype.renderEmptyIcon = function () {
        return (React.createElement("svg", null,
            React.createElement("use", { xlinkHref: this.question.dashSvgIcon })));
    };
    SurveyQuestionRankingItem.prototype.renderElement = function () {
        var itemContent = ReactElementFactory.Instance.createElement(this.question.itemComponent, { item: this.item, cssClasses: this.cssClasses });
        return (React.createElement("div", { id: this.question.getItemId(this.item), tabIndex: this.itemTabIndex, className: this.itemClass, onKeyDown: this.handleKeydown, onPointerDown: this.handlePointerDown, onPointerUp: this.handlePointerUp, "data-sv-drop-target-ranking-item": this.index },
            React.createElement("div", { tabIndex: -1, style: { outline: "none" } },
                React.createElement("div", { className: this.cssClasses.itemGhostNode }),
                React.createElement("div", { className: this.cssClasses.itemContent },
                    React.createElement("div", { className: this.cssClasses.itemIconContainer },
                        React.createElement("svg", { className: this.question.getIconHoverCss() },
                            React.createElement("use", { xlinkHref: this.question.dragDropSvgIcon })),
                        React.createElement("svg", { className: this.question.getIconFocusCss() },
                            React.createElement("use", { xlinkHref: this.question.arrowsSvgIcon }))),
                    React.createElement("div", { className: this.question.getItemIndexClasses(this.item) }, (!this.unrankedItem && this.indexText) ? this.indexText : this.renderEmptyIcon()),
                    itemContent))));
    };
    return SurveyQuestionRankingItem;
}(ReactSurveyElement));
export { SurveyQuestionRankingItem };
var SurveyQuestionRankingItemContent = /** @class */ (function (_super) {
    __extends(SurveyQuestionRankingItemContent, _super);
    function SurveyQuestionRankingItemContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionRankingItemContent.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionRankingItemContent.prototype, "cssClasses", {
        get: function () {
            return this.props.cssClasses;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionRankingItemContent.prototype.renderElement = function () {
        return React.createElement("div", { className: this.cssClasses.controlLabel }, SurveyElementBase.renderLocString(this.item.locText));
    };
    return SurveyQuestionRankingItemContent;
}(ReactSurveyElement));
export { SurveyQuestionRankingItemContent };
ReactElementFactory.Instance.registerElement("sv-ranking-item", function (props) {
    return React.createElement(SurveyQuestionRankingItemContent, props);
});
ReactQuestionFactory.Instance.registerQuestion("ranking", function (props) {
    return React.createElement(SurveyQuestionRanking, props);
});
